// extracted by mini-css-extract-plugin
export default {"mainContainer":"Title_mainContainer__RxsLf","holderTitle":"Title_holderTitle__wWtav","title":"Title_title__hBirv","subtitle":"Title_subtitle__Xo-65"};